import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuloFunzioniRuoliComponent } from './modulo-funzioni-ruoli.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
@NgModule({
    imports: [
        CommonModule,
        TranslatePipe, TranslateDirective,
    ],
    declarations: [ModuloFunzioniRuoliComponent],
    exports: [ModuloFunzioniRuoliComponent]
})
export class FunzioniRuoliModule { }
